import type { PayrollExternalExportRowV1 } from "@impetusos/contracts"
import type { ReactElement } from "react"

export interface PayrollExternalExportPanelProps {
  status: "loading" | "ready" | "empty" | "error" | "denied"
  reasonCode?: string
  rows: readonly PayrollExternalExportRowV1[]
  onRetry: () => void
  onExport: () => void
}

export function PayrollExternalExportPanel({
  status,
  reasonCode,
  rows,
  onRetry,
  onExport,
}: PayrollExternalExportPanelProps): ReactElement {
  if (status === "loading") return <p aria-live="polite">Loading approved payroll inputs…</p>
  if (status === "denied") return <p role="alert">You do not have access to payroll exports.</p>
  if (status === "error") return (
    <div role="alert">
      <p>Approved payroll inputs are temporarily unavailable.</p>
      <button type="button" onClick={onRetry}>Try again</button>
    </div>
  )
  if (status === "empty" || rows.length === 0) return <p>No approved time or payables are ready to export.</p>
  return (
    <section aria-labelledby="payroll-external-export-title">
      <h2 id="payroll-external-export-title">External payroll processing</h2>
      <p>
        ImpetusOS payroll finalization is unavailable ({reasonCode?.replaceAll("_", " ")}).
        Export approved inputs and provenance for your authorized external process.
      </p>
      <p role="note">This export does not calculate or finalize payroll in ImpetusOS.</p>
      <p>{rows.length} approved input{rows.length === 1 ? "" : "s"} ready.</p>
      <button type="button" onClick={onExport}>Download versioned CSV</button>
    </section>
  )
}
